import type { PlaybackState } from '../../types';

interface YouTubeVideoThumbnailProps {
  playerId: string;
  playbackState: PlaybackState;
  isPlaying: boolean;
  onPlay: () => void;
  onPause: () => void;
}

export function YouTubeVideoThumbnail({
  playerId,
  playbackState,
  isPlaying,
  onPlay,
  onPause,
}: YouTubeVideoThumbnailProps) {
  const isLoading = playbackState === 'loading';
  const showOverlay = !isPlaying || playbackState === 'paused' || playbackState === 'none';

  return (
    <div className="fixed bottom-4 right-4 z-40">
      <div className="group relative w-[140px] h-[78px] sm:w-[178px] sm:h-[100px] rounded-lg overflow-hidden shadow-xl border border-black/10 dark:border-white/10 bg-black/20 dark:bg-black/40">
        <div id={playerId} className="w-full h-full" />

        <div
          className={`absolute inset-0 flex items-center justify-center transition-opacity duration-200 ${
            showOverlay ? 'opacity-100' : 'opacity-0 group-hover:opacity-100'
          }`}
        >
          <button
            type="button"
            onClick={isPlaying ? onPause : onPlay}
            className="w-10 h-10 rounded-full bg-black/60 text-white flex items-center justify-center shadow-md hover:bg-black/70 transition-colors"
            aria-label={isPlaying ? 'Pause YouTube playback' : 'Play YouTube playback'}
          >
            {isLoading ? (
              <div className="w-4 h-4 border-2 border-white/30 border-t-white rounded-full animate-spin" />
            ) : isPlaying ? (
              <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 24 24">
                <path d="M6 4h4v16H6V4zm8 0h4v16h-4V4z" />
              </svg>
            ) : (
              <svg className="w-5 h-5 ml-0.5" fill="currentColor" viewBox="0 0 24 24">
                <path d="M8 5v14l11-7z" />
              </svg>
            )}
          </button>
        </div>

        <div className="absolute top-1 left-1 px-1.5 py-0.5 rounded bg-red-600/90 text-[10px] font-semibold uppercase tracking-wide text-white shadow">
          YouTube
        </div>
      </div>
    </div>
  );
}
